var map = {
	".": [
		14
	],
	"./": [
		14
	],
	"./App": [
		26
	],
	"./App.jsx": [
		26
	],
	"./App.test": [
		93,
		23
	],
	"./App.test.js": [
		93,
		23
	],
	"./assets/fonts/thaisanslite_r1.ttf": [
		161,
		98
	],
	"./assets/images/admission/background.svg": [
		205,
		97
	],
	"./assets/images/admission/bottomLeft.svg": [
		219,
		96
	],
	"./assets/images/admission/bottomRight.svg": [
		220,
		95
	],
	"./assets/images/admission/coupon-bg-mobile.png": [
		164,
		39
	],
	"./assets/images/admission/coupon-bg.svg": [
		165,
		94
	],
	"./assets/images/admission/coupon-success.png": [
		166,
		38
	],
	"./assets/images/admission/icons/email.svg": [
		167,
		93
	],
	"./assets/images/admission/icons/facebook.svg": [
		168,
		92
	],
	"./assets/images/admission/icons/instagram.svg": [
		169,
		91
	],
	"./assets/images/admission/icons/line.svg": [
		170,
		90
	],
	"./assets/images/admission/icons/phone.svg": [
		171,
		89
	],
	"./assets/images/admission/icons/twitter.svg": [
		172,
		88
	],
	"./assets/images/admission/logo-grey.svg": [
		221,
		87
	],
	"./assets/images/admission/logo.svg": [
		199,
		86
	],
	"./assets/images/admission/menu.png": [
		193,
		37
	],
	"./assets/images/admission/payment-bg.svg": [
		159,
		85
	],
	"./assets/images/admission/placeholder.png": [
		222,
		36
	],
	"./assets/images/admission/success-payment-icon.svg": [
		162,
		84
	],
	"./assets/images/counter-service.png": [
		223,
		35
	],
	"./assets/images/download_app_store.svg": [
		206,
		83
	],
	"./assets/images/download_play_store.svg": [
		207,
		82
	],
	"./assets/images/intro-kiddy.mp4": [
		208,
		81
	],
	"./assets/images/intro-official.mp4": [
		209,
		80
	],
	"./assets/images/intro.mp4": [
		210,
		79
	],
	"./assets/images/iphone.svg": [
		200,
		78
	],
	"./assets/images/kiddy/BG.svg": [
		211,
		77
	],
	"./assets/images/kiddy/Onboarding-1.svg": [
		173,
		76
	],
	"./assets/images/kiddy/Onboarding-2.svg": [
		174,
		75
	],
	"./assets/images/kiddy/Onboarding-3.svg": [
		175,
		74
	],
	"./assets/images/kiddy/Onboarding-4.svg": [
		176,
		73
	],
	"./assets/images/kiddy/background.svg": [
		224,
		72
	],
	"./assets/images/kiddy/icons/email.svg": [
		177,
		71
	],
	"./assets/images/kiddy/icons/facebook.svg": [
		178,
		70
	],
	"./assets/images/kiddy/icons/instagram.svg": [
		179,
		69
	],
	"./assets/images/kiddy/icons/line.svg": [
		180,
		68
	],
	"./assets/images/kiddy/icons/phone.svg": [
		181,
		67
	],
	"./assets/images/kiddy/icons/twitter.svg": [
		182,
		66
	],
	"./assets/images/kiddy/logo.svg": [
		201,
		65
	],
	"./assets/images/kiddy/menu.svg": [
		194,
		64
	],
	"./assets/images/logo-font.png": [
		195,
		34
	],
	"./assets/images/logo-font@2x.png": [
		225,
		33
	],
	"./assets/images/logo-font@3x.png": [
		226,
		32
	],
	"./assets/images/logo-kiddy.svg": [
		196,
		63
	],
	"./assets/images/logo-official.png": [
		197,
		31
	],
	"./assets/images/logo-official.svg": [
		227,
		62
	],
	"./assets/images/official/background-layer-1.svg": [
		212,
		61
	],
	"./assets/images/official/background-layer-2.svg": [
		213,
		60
	],
	"./assets/images/official/background-layer-3.svg": [
		214,
		59
	],
	"./assets/images/official/background.svg": [
		215,
		58
	],
	"./assets/images/official/bottomLeft.svg": [
		228,
		57
	],
	"./assets/images/official/bottomRight.svg": [
		229,
		56
	],
	"./assets/images/official/character.svg": [
		230,
		55
	],
	"./assets/images/official/coupon-background.svg": [
		231,
		54
	],
	"./assets/images/official/coupon-bg-mobile.png": [
		183,
		30
	],
	"./assets/images/official/coupon-bg.svg": [
		184,
		53
	],
	"./assets/images/official/coupon-success.png": [
		185,
		29
	],
	"./assets/images/official/dashed-line.svg": [
		186,
		52
	],
	"./assets/images/official/icons/email.svg": [
		187,
		51
	],
	"./assets/images/official/icons/facebook.svg": [
		188,
		50
	],
	"./assets/images/official/icons/instagram.svg": [
		189,
		49
	],
	"./assets/images/official/icons/line.svg": [
		190,
		48
	],
	"./assets/images/official/icons/phone.svg": [
		191,
		47
	],
	"./assets/images/official/icons/twitter.svg": [
		192,
		46
	],
	"./assets/images/official/login-bg.svg": [
		232,
		45
	],
	"./assets/images/official/logo-grey.svg": [
		233,
		44
	],
	"./assets/images/official/logo.svg": [
		202,
		43
	],
	"./assets/images/official/menu.png": [
		198,
		28
	],
	"./assets/images/official/package-bg.svg": [
		160,
		42
	],
	"./assets/images/official/placeholder.png": [
		234,
		27
	],
	"./assets/images/official/promotion-ribbon.svg": [
		235,
		41
	],
	"./assets/images/official/success-payment-icon.svg": [
		163,
		40
	],
	"./components/ContactModal": [
		78,
		8
	],
	"./components/ContactModal.jsx": [
		78,
		8
	],
	"./components/CouponModal": [
		79,
		6
	],
	"./components/CouponModal.jsx": [
		79,
		6
	],
	"./components/FeatureSection": [
		85,
		9
	],
	"./components/FeatureSection.jsx": [
		85,
		9
	],
	"./components/Footer": [
		86,
		10
	],
	"./components/Footer.jsx": [
		86,
		10
	],
	"./components/Header": [
		87,
		4
	],
	"./components/Header.jsx": [
		87,
		4
	],
	"./components/LoginModal": [
		83,
		5
	],
	"./components/LoginModal.jsx": [
		83,
		5
	],
	"./components/PaymentModal": [
		25,
		0
	],
	"./components/PaymentModal/": [
		25,
		0
	],
	"./components/PaymentModal/AdmissionModal": [
		74,
		18
	],
	"./components/PaymentModal/AdmissionModal.jsx": [
		74,
		18
	],
	"./components/PaymentModal/CounterServiceForm": [
		72,
		14
	],
	"./components/PaymentModal/CounterServiceForm.jsx": [
		72,
		14
	],
	"./components/PaymentModal/CreditCardForm": [
		71,
		13
	],
	"./components/PaymentModal/CreditCardForm.jsx": [
		71,
		13
	],
	"./components/PaymentModal/OfficialModal": [
		73,
		17
	],
	"./components/PaymentModal/OfficialModal.jsx": [
		73,
		17
	],
	"./components/PaymentModal/Payment.class": [
		76,
		20
	],
	"./components/PaymentModal/Payment.class.js": [
		76,
		20
	],
	"./components/PaymentModal/SuccessPayment": [
		75,
		21
	],
	"./components/PaymentModal/SuccessPayment.jsx": [
		75,
		21
	],
	"./components/PaymentModal/index": [
		25,
		0
	],
	"./components/PaymentModal/index.jsx": [
		25,
		0
	],
	"./components/PrimaryButton": [
		69,
		16
	],
	"./components/PrimaryButton.jsx": [
		69,
		16
	],
	"./components/PrivacyPolicy": [
		81,
		12
	],
	"./components/PrivacyPolicy.jsx": [
		81,
		12
	],
	"./components/SecondaryButton": [
		70,
		15
	],
	"./components/SecondaryButton.jsx": [
		70,
		15
	],
	"./components/TermOfService": [
		82,
		11
	],
	"./components/TermOfService.jsx": [
		82,
		11
	],
	"./config": [
		67,
		22
	],
	"./config.js": [
		67,
		22
	],
	"./firebase": [
		68,
		7
	],
	"./firebase.js": [
		68,
		7
	],
	"./index": [
		14
	],
	"./index.js": [
		14
	],
	"./registerServiceWorker": [
		27
	],
	"./registerServiceWorker.js": [
		27
	],
	"./util/kiddy.data": [
		80,
		19
	],
	"./util/kiddy.data.js": [
		80,
		19
	],
	"./view/Admission": [
		94,
		3
	],
	"./view/Admission.jsx": [
		94,
		3
	],
	"./view/Kiddy": [
		95,
		2
	],
	"./view/Kiddy.jsx": [
		95,
		2
	],
	"./view/Official": [
		96,
		1
	],
	"./view/Official.jsx": [
		96,
		1
	],
	"./view/admission.css": [
		216,
		26
	],
	"./view/kiddy.css": [
		217,
		25
	],
	"./view/official.css": [
		218,
		24
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 158;
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src lazy ^.*$
// module id = 158
// module chunks = 99